import React from "react";
import IndustriaDeDefensa from "Components/IndustriaDeDefensa";

const IndustriaDeDefensaPage = () => {
  return <IndustriaDeDefensa />;
};

export default IndustriaDeDefensaPage;
